// Generated by purs version 0.14.5
"use strict";
var Data_Lens_Internal_Exchange = require("../Data.Lens.Internal.Exchange/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Internal_Grating = require("../Data.Lens.Internal.Grating/index.js");
var Data_Lens_Internal_Indexed = require("../Data.Lens.Internal.Indexed/index.js");
var Data_Lens_Internal_Market = require("../Data.Lens.Internal.Market/index.js");
var Data_Lens_Internal_Re = require("../Data.Lens.Internal.Re/index.js");
var Data_Lens_Internal_Shop = require("../Data.Lens.Internal.Shop/index.js");
var Data_Lens_Internal_Stall = require("../Data.Lens.Internal.Stall/index.js");
var Data_Lens_Internal_Tagged = require("../Data.Lens.Internal.Tagged/index.js");
var Data_Lens_Internal_Wander = require("../Data.Lens.Internal.Wander/index.js");
module.exports = {
    Exchange: Data_Lens_Internal_Exchange.Exchange,
    Forget: Data_Lens_Internal_Forget.Forget,
    Indexed: Data_Lens_Internal_Indexed.Indexed,
    Market: Data_Lens_Internal_Market.Market,
    Re: Data_Lens_Internal_Re.Re,
    Shop: Data_Lens_Internal_Shop.Shop,
    Stall: Data_Lens_Internal_Stall.Stall,
    Tagged: Data_Lens_Internal_Tagged.Tagged,
    wander: Data_Lens_Internal_Wander.wander
};
